<template>
  <div class="group-list">
    <div class="group" v-for="(group, letter) in groupList" :key="letter">
      <div class="letter">{{ letter }}</div>
      <ul>
        <touch tag="li" v-for="item in group" :key="item.id" @tap="joinin(item)">
          <webp-image class="logo" :src="item.icon" alt="logo" />
          <div class="name">{{ item.name }}</div>
        </touch>
      </ul>
    </div>
    <modal v-show="showModal" title="加入战队" @confirm="confirm" @cancel="cancel">
      <p slot="message">确认支持 <strong>{{selected.name}}</strong> 战队，<br/>为它助力！确定后无法更改哦。</p>
    </modal>
  </div>
</template>

<script>
  import actions from '@/store/action-types'

  import WebpImage from '@/components/common/WebpImage'
  import Modal from '@/components/common/Modal'

  export default {
    data () {
      return {
        showModal: false,
        selected: {
          id: 0,
          name: ''
        }
      }
    },
    computed: {
      groupList () {
        return this.$store.getters.groupList
      }
    },
    created () {
      this.getGroupList()
    },
    activated () {
      this.$track.sendPageTrack('csr_select_organization')
    },
    methods: {
      openModal () {
        this.showModal = true
      },
      closeModal () {
        this.showModal = false
      },
      getGroupList () {
        this.$store.dispatch(actions.fetch.GROUP_LIST)
      },
      joinin ({ id, name }) {
        this.selected = { id, name }
        this.$track.sendActionTrack('csr_select_organization', 'click_select', {
          organization_id: id
        })
        this.openModal()
      },
      confirm () {
        this.$store.dispatch(actions.post.JOININ_GROUP, {
          id: this.selected.id
        }).then(() => {
          this.$track.sendActionTrack('csr_select_organization', 'click_check_pop', {
            status: 1
          })
          this.gotoGroupRanking()
          this.closeModal()
        })
      },
      cancel () {
        this.$track.sendActionTrack('csr_select_organization', 'click_check_pop', {
          status: 0
        })
        this.closeModal()
      },
      gotoGroupRanking () {
        this.$router.replace({name: 'ranking', params: {tab: 'group'}})
      }
    },
    components: {
      WebpImage,
      Modal
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/scss/vars";

  .group-list {
    .group {
      background-color: $white;
    }
    .letter {
      height: 40px;
      padding-left: 40px;
      font-size: 28px;
      line-height: 40px;
      background-color: $grey;
    }
    ul {
      padding-left: 40px;
      padding-right: 40px;
      li {
        display: flex;
        padding-top: 30px;
        padding-bottom: 30px;
        border-bottom: 2px solid rgba(#979797, 0.2);
        &:last-child {
          border-bottom: none;
        }
        .logo {
          width: 80px;
          height: 80px;
          margin-right: 30px;
        }
        .name {
          @include text-ellipsis;
          flex: 1;
          font-size: 30px;
          font-weight: 400;
          color: $black;
          line-height: 80px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GroupList.vue?303382ca